<template>
  <div class="header" :style="{ paddingTop: topHeight }">
    <div style="display: flex; flex-direction: column; width: 100%; background-image: url('/static/images/header-bg.jpg'); background-size: 100% 132%">
      <div class="top-bar">
        <div 
          class="lang" 
          :class="{ 'unset': applicationLocale !== item.code }" 
          v-for="(item, index) in locales"
          :key="index" 
          @click="onLocaleChange(item)"
        >
          <img src="/static/images/lang_cn.png" class="image" v-if="item.code === 'zh-Hans'" />
          <img src="/static/images/lang_en.png" class="image" v-else />
          {{ item.text }}
        </div>
      </div>
      <div class="container">
        <div class="logo">
          <img :src="config.logo_url" @click="category('logo')" />
          <el-input
            v-model="title"
            :placeholder="$t('index.search-input-text')"
            class="searchBar"
            @keyup.enter.native="search(title)"
            @clear="clear"
            clearable
            style="max-width: 200px;"
          >
            <el-button slot="append" icon="el-icon-search" @click="search(title)"></el-button>
          </el-input>
          <i 
            :class="showNav ? 'el-icon-close' : 'el-icon-menu'" 
            class="mobile-nav-icon" 
            style="color: #fff; font-size: 30px; cursor: pointer; display: none;"
            @click="open('nav')"
          ></i>
        </div>
      </div>
      <div class="nav">
        <div class="container" style="padding: 0;">
          <div class="menu">
            <div class="li" @click="category(0)" :class="!id ? 'active' : ''">{{ $t('index.home') }}</div>
            <div 
              class="li" 
              v-for="(item, ind) in typeList" 
              :key="ind"  
              :class="String(item.id) === String(id) ? 'active' : showSubMenu && ind === showSubMenuIndex ? 'hover' : ''"  
              @mouseenter="handleMouseEnter(ind)" 
              @mouseleave="handleMouseLeave(ind)"
            >
              <div @click="category(item.id)">{{ applicationLocale === 'en' ? item.name_en : item.name }}</div>
              <div 
                style="position: absolute; top: 50px; left: 0; background: #000; z-index: 99; display: flex; flex-direction: column; line-height: 40px;" 
                v-if="showSubMenu && ind === showSubMenuIndex"
              >
                <div 
                  v-for="(children, i) in item.children" 
                  :key="i" 
                  style="padding: 0 30px; border-bottom: #999;" 
                  @click="category(children.id)"
                >
                  {{ applicationLocale === 'en' ? children.name_en : children.name }}
                </div>
              </div>
            </div>
            <div class="li" @click="category(98)" :class="String(id) === '98' ? 'active' : ''">{{ $t('bingo.bingo') }}</div>
            <div class="li" @click="category(101)" :class="String(id) === '101' ? 'active' : ''">{{ $t('index.liveStream') }}</div>
            <div class="li" @click="category(99)" :class="String(id) === '99' ? 'active' : ''">{{ $t('index.liveScore') }}</div>
            <div class="li" @click="category(100)" :class="String(id) === '100' ? 'active' : ''">{{ $t('index.liveBroadcast') }}</div>
            <div class="li" @click="category(102)" :class="String(id) === '102' ? 'active' : ''">{{ $t('index.contactUs') }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <el-drawer
      :visible.sync="drawerVisible"
      direction="ltr"
      :with-header="false"
      size="300px"
    >
      <div class="mobile-nav">
        <div class="li" @click="category(0)" :class="!id ? 'active' : ''">{{ $t('index.home') }}</div>
        <div class="li" v-for="(item, index) in typeList" :key="index" @click="category(item.id)" :class="String(item.id) === String(id) ? 'active' : ''">
          {{ applicationLocale === 'en' ? item.name_en : item.name }}
        </div>
        <div class="li" @click="category(98)" :class="String(id) === '98' ? 'active' : ''">{{ $t('bingo.bingo') }}</div>
        <div class="li" @click="category(101)" :class="String(id) === '101' ? 'active' : ''">{{ $t('index.liveStream') }}</div>
        <div class="li" @click="category(99)" :class="String(id) === '99' ? 'active' : ''">{{ $t('index.liveScore') }}</div>
        <div class="li" @click="category(100)" :class="String(id) === '100' ? 'active' : ''">{{ $t('index.liveBroadcast') }}</div>
        <div class="li" @click="category(102)" :class="String(id) === '102' ? 'active' : ''">{{ $t('index.contactUs') }}</div>
        
        <div style="flex-direction: column; margin-top: 30px;">
          <div 
            class="lang" 
            :class="{ 'unset': applicationLocale !== item.code }" 
            v-for="(item, index) in locales" 
            :key="index" 
            @click="onLocaleChange(item)" 
            style="margin: 6px;"
          >
            <img src="/static/images/lang_cn.png" class="image" v-if="item.code === 'zh-Hans'"></img>
            <img src="/static/images/lang_en.png" class="image" v-else></img>
            {{ item.text }}
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import api from '@/api/'
import storage from '@/utils/storage'
import i18nUtil from '@/utils/i18n'
import { Message, MessageBox } from 'element-ui'

export default {
  name: 'Header',
  props: {
    applicationLocale: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lang: 'cn',
      systemLocale: '',
      topHeight: '',
      id: '',
      typeList: [],
      showNav: false,
      config: '',
      isHome: false,
      title: '',
      showSubMenu: false,
      showSubMenuIndex: 0,
      drawerVisible: false
    }
  },
  computed: {
    locales() {
      return [
        {
          text: this.$t('locale.zh-hans'),
          code: 'zh-Hans'
        },
        {
          text: this.$t('locale.en'),
          code: 'en'
        }
      ]
    }
  },
  watch: {
    '$route'(to, from) {
      // 当路由变化时更新 id 和 title
      this.updateRouteInfo()
    }
  },
  mounted() {
    this.typeList = storage.getItem('type') || []
    this.config = storage.getItem('config') || {}
    if (!storage.getItem('type')) this.getTypeList()
    if (!storage.getItem('ad')) this.getAd()
    if (!this.config || !this.config.name) {
      this.getConfig()
    } else {
      this.setting()
    }
    this.updateRouteInfo()
  },
  methods: {
    updateRouteInfo() {
      // 更新路由相关的信息
      if (this.$route.path === '/pages/index/index' || this.$route.path === '/') {
        this.isHome = true
        this.id = ''
      } else {
        this.isHome = false
        this.id = this.$route.query.id || ''
      }
      this.title = this.$route.query.title || ''
    },
    setting() {
      if (this.config && this.config.name) {
        document.title = this.config.name
      }
      this.updateRouteInfo()
      this.$nextTick(() => {
        if (this.config.keywords) {
          let meta = document.querySelector('head > meta[name=keywords]')
          if (meta) {
            meta.setAttribute('content', this.config.keywords)
          } else {
            const newMeta = document.createElement('meta')
            newMeta.setAttribute('name', 'keywords')
            newMeta.setAttribute('content', this.config.keywords)
            document.getElementsByTagName('head')[0].appendChild(newMeta)
          }
        }
        
        if (this.config.description) {
          let meta1 = document.querySelector('head > meta[name=description]')
          if (meta1) {
            meta1.setAttribute('content', this.config.description)
          } else {
            const newMeta1 = document.createElement('meta')
            newMeta1.setAttribute('name', 'description')
            newMeta1.setAttribute('content', this.config.description)
            document.getElementsByTagName('head')[0].appendChild(newMeta1)
          }
        }
        
        if (this.config.ico_url) {
          let link = document.querySelector('head > link[rel=icon]')
          if (link) {
            link.setAttribute('href', this.config.ico_url)
          } else {
            const newLink = document.createElement('link')
            newLink.setAttribute('rel', 'icon')
            newLink.setAttribute('href', this.config.ico_url)
            document.getElementsByTagName('head')[0].appendChild(newLink)
          }
        }
      })
    },
    category(id) {
      if (id === 'logo') {
        if (this.config.logo_link) {
          window.location.href = this.config.logo_link
        }
      } else if (id === 0) {
        if (this.$route.path !== '/pages/index/index' && this.$route.path !== '/') {
          this.$router.push('/pages/index/index').catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
          })
        }
      } else if (id === 98) {
        const targetPath = '/pages/bingo/index'
        if (this.$route.path !== targetPath || this.$route.query.id !== String(id)) {
          this.$router.push({ path: targetPath, query: { id } }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
          })
        }
      } else if (id === 99) {
        const targetPath = '/pages/sports/livescore'
        if (this.$route.path !== targetPath || this.$route.query.id !== String(id)) {
          this.$router.push({ path: targetPath, query: { id } }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
          })
        }
      } else if (id === 100) {
        const targetPath = '/pages/sports/index'
        if (this.$route.path !== targetPath || this.$route.query.id !== String(id)) {
          this.$router.push({ path: targetPath, query: { id } }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
          })
        }
      } else if (id === 101) {
        const targetPath = '/pages/liveStream/index'
        if (this.$route.path !== targetPath || this.$route.query.id !== String(id)) {
          this.$router.push({ path: targetPath, query: { id } }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
          })
        }
      } else if (id === 102) {
        const targetPath = '/pages/contact/index'
        if (this.$route.path !== targetPath || this.$route.query.id !== String(id)) {
          this.$router.push({ path: targetPath, query: { id } }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
          })
        }
      } else {
        const targetPath = '/pages/news/category'
        const currentId = this.$route.query.id
        if (this.$route.path !== targetPath || String(currentId) !== String(id)) {
          this.$router.push({ path: targetPath, query: { id } }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
          })
        }
      }
      this.drawerVisible = false
      this.showNav = false
    },
    handleImageError(item) {
      // 处理图片显示错误
    },
    open(val) {
      if (val == 'nav') {
        this.drawerVisible = !this.drawerVisible
        this.showNav = this.drawerVisible
      }
    },
    onLocaleChange(e) {
      i18nUtil.setLocale(e.code)
      this.$i18n.locale = e.code
      this.$emit('changeLang', e.code)
    },
    getTypeList() {
      api.getData('index/typeList')
        .then((res) => {
          storage.setItem('type', res.data.data)
          this.typeList = res.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getConfig() {
      api.getData('index/config', { id: 1 })
        .then((res) => {
          storage.setItem('config', res.data.data)
          this.config = res.data.data
          this.setting()
          this.$emit('getConfig', res.data.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getAd() {
      api.getData('index/bannerList', { type: -1 })
        .then((res) => {
          storage.setItem('ad', res.data.data)
          this.$emit('getAd', res.data.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    clear() {
      this.title = ''
    },
    search(val) {
      this.title = val
      const targetPath = '/pages/news/category'
      const currentTitle = this.$route.query.title
      if (this.$route.path !== targetPath || String(currentTitle) !== String(val)) {
        this.$router.push({ path: targetPath, query: { title: val } }).catch(err => {
          if (err.name !== 'NavigationDuplicated') console.error(err)
        })
      }
    },
    handleMouseEnter(index) {
      if (index) {
        this.showSubMenu = true
        this.showSubMenuIndex = index
      }
    },
    handleMouseLeave(index) {
      this.showSubMenu = false
      this.showSubMenuIndex = 0
    }
  }
}
</script>

<style>
@import '../../public/static/css/index.css';
</style>
